// src/features/people/DocumentForm.jsx
import React from 'react';
import DocumentUploadForm from '../../components/DocumentUploadForm';
import PeopleService from './PeopleService';

function DocumentForm({ personId, document = null, onSave, onCancel }) {
  return (
    <DocumentUploadForm
      service={PeopleService}
      ownerId={personId}
      document={document}
      onSave={onSave}
      onCancel={onCancel}
      createLabel="Guardar"
    />
  );
}

export default DocumentForm;
